export default {
  subMenu: store => store.subMenu || {},
  assetSubMenu: store => store.assetSubMenu || {},
};
